/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/


define (["underscore", "backbone", "utils/jsonpath", "utils/clone", "utils/trace"],
    function(_, Backbone, JSONPath, clone, Trace) {

  // A tree model node has a path and rootModel
  // In case of a change it does not directly persist it, but sets it on the parent
  // with the given path.
  var TreeModelNode = function(treeModel, path, attributes, options) {
    this.treeModel = treeModel;  // of type ReadonlyTreeRoot
    this.path = path;
    this.pathElts  = JSONPath.parsePath(this.path);
    this.canoncialPath = JSONPath.stringifyPath(this.pathElts);
    this.attributes = JSONPath.get(attributes, this.pathElts);
    this.aliases = {};
    this.listenTo(this.treeModel, "change", this._onTreeChange, this);
    // invalidate is called before change is triggered.
    this.listenTo(this.treeModel, "invalidate", this._onTreeInvalidate, this);
  }

  _.extend(TreeModelNode.prototype, Backbone.Events, {

    clone: function () {
      return new TreeModelNode(this.treeModel.clone(), this.path, clone(this.attributes));
    },

    _onTreeInvalidate: function(treeModel, options) {
      var previousAttributes = this.attributes;
      this.attributes = JSONPath.get(this.treeModel.attributes, this.pathElts);
    },

    _onTreeChange: function(treeModel, options) {

      // in this case we ar only interested in local events
      // we are not interested if some thing els in the tree changed.

      // ignore changes that are not part of this submodel
      // if (!JSONPath.startsWith(path, this.path)) {
      //  return;
      // }

      // var previousAttributes = this.attributes;
      // this.attributes = JSONPath.get(this.treeModel.attributes, this.pathElts);

      //if (previousAttributes != this.attributes) {
        // TODO: Calculate the difference in the attributes
        this.trigger("change", this, options);
      //}
    },


    exists: function() {
      return this.treeModel.get(this.pathElts) != null;
    },

    _fullPath: function(options) {
      var path = this.pathElts;
      var subPath = options && options.path || null;
      if (subPath != null) {
        if (!_.isArray(subPath)) {
          subPath = JSONPath.parsePath(subPath);
        }
        path = path.concat(subPath);
      }
      return path;
    },

    set: function(key, val, options) {

      if (_.isObject(key)) {
        options = val;
      }

      var path = this._fullPath(options);
      if (key == null && path.length > 0) {
        key = JSON.stringify(path[path.length - 1]);
        path = path.slice(0, -1);
      }

      if (_.isObject(key) /* && !_.isArray(key)*/) {
        var attrs = key;
        options = _.extend({aliases: this.aliases}, options, {path: path});
        this.treeModel.set(attrs, options);
      }
      else {
        options = _.extend({aliases: this.aliases}, options, {path: path});
        this.treeModel.set(key, val, options);
      }
      return this;
    },

    clear: function(options) {
      var path = this._fullPath(options);
      this.treeModel.set(undefined, undefined, _.extend({}, options, {unset: true, path: path}));
      return this;
    },
    
    unset: function(key, options) {
      return this.set(key, undefined, _.extend({}, options, {unset: true}));
    },

    add: function(key, val, options) {
//      if (_.isObject(key)) {
//        options = val;
//        var attrs = key;
//        options = _.extend({path: this.path, aliases: this.aliases}, options);
//        this.treeModel.set(attrs, options);
//      }

      options = _.extend({path: this.path, aliases: this.aliases}, options);
      this.treeModel.add(key, val, options);

      return this;
    },

    change: function(options) {
      options = options || {};
      options = _.extend({path: this.path, aliases: this.aliases}, options);
      this.treeModel.change(options);
      return this;
    },

    toJSON: function() {
      return clone(this.attributes);
    },

    _get: function(attr) {
      if (attr == null) return this.attributes;

      if (!this.attributes ) return null;

      var result = this.attributes[attr];
      if (result === undefined) {
        var path = this.aliases[attr];
        if (path) {
          return this.treeModel.get(path);
        }
      }

      if (result === undefined) {
        var parsedPath = JSONPath.parsePath(attr);
        if (!parsedPath) return result;

        result = JSONPath.get(this.attributes, attr);
        if (result !== undefined) {
          return result;
        }

        if (_.isArray(parsedPath) && parsedPath.length > 0) {
          var basePath = this.aliases[parsedPath[0]];
          if (basePath && _.isArray(basePath)) {
            var path = basePath.concat(parsedPath.slice(1));
            return this.treeModel.get(path);
          }
        }
      }
      return result;
    },

    get: function(attr) {
      var result = this._get.apply(this, arguments);
      if (_.isObject(result)) {
        return clone(result);
      }
      return result;
    },

    dispose: function() {
      this.stopListening(this.treeModel);
      this.treeModel = null;
      this.aliases = {};
    },

    addAlias: function(alias, path) {
      this.aliases[alias] = JSONPath.parsePath(path);
      // maybe also fire an event here
    },

    removeAlias: function(alias) {
      delete this.aliases[alias];
    },


    submodel: function(path, options) {
      if (!_.isArray(path)) {
        path = JSONPath.parsePath(path);
      }
      path = this.pathElts.concat(path);
      return this.treeModel.submodel(path, options);
    }

  });


  var TreeModel = function(attributes, options) {
    options = options || {};
    var attrs = attributes || {};
    this.cid = _.uniqueId('c');
    this.attributes = {};
    this._changes = [];
    // silent will track the changes, but will not n
    this.load(attrs, _.extend({silent:true}, options));

    // initializing attributes now, makes the recorded changes
    // not notified.
    this._currentAttributes = clone(this.attributes);
    this._previousAttributes = clone(this.attributes);
    this.initialize.apply(this, arguments);
  }

  _.extend(TreeModel.prototype, Backbone.Events, {

    initialize: function(attributes, options) {
    },

    addValidator: function (validator) {
      if (typeof validator !== "function") return;

      this._validators = this._validators || [];
      this._validators.push(validator);
      this._reValidate();
    },

    removeValidator: function (toRemove) {
      this._validators = _.filter(this._validators, function (validator) {
        return validator !== toRemove;
      });
    },

    validate: function () {
      var that = this;
      return _.reduce(this._validators, function (valid, validator) {
          if (!valid || !validator()) {
            return false;
          }
          return valid;
        }, true);
    },

    _reValidate: function () {
      var valid = this.validate();
      if (valid !== this._previouslyValid) {
        this._previouslyValid = valid;
        this.trigger("validated", this, valid);
        if (valid) {
          this.trigger("validated:valid", this, valid);
        } else {
          this.trigger("validated:invalid", this, valid);
        }
      }
    },

    setSilent: function(v) {
      this.silent = v;
      // console.log("set silent:", v, this._computeChanges(false));
    },

    clone: function () {
      return new this.constructor(clone(this.attributes));
    },

    submodel: function(path, options) {
       return new TreeModelNode(this, path, this.attributes, options);
    },

    // **parse** converts a response into the hash of attributes to be `set` on
    // the model. The default implementation is just to pass the response along.
    parse: function(resp) {
      return resp;
    },

    // **load** reinitializes the tree from attributes, parses first
    load: function(attributes, options) {
      var attrs = attributes || {};
      var leave,
          traceContext;

      options = options || {};

      traceContext = options.traceContext;

      if (options.parse) {
        leave = Trace.events.outputParse.enter(traceContext && traceContext.context);
        options.traceContext = leave;
        attrs = this.parse(attributes, options);
        leave.leave();
      }
      if (options.merge) {
        leave = Trace.events.outputParse.enter(traceContext && traceContext.context);
        options.traceContext = leave;
        var existingAtts = clone(this.attributes);
        attrs = this.merge(existingAtts, attrs, options);
        leave.leave();
      }

      options.traceContext = traceContext;

      this.set(attrs, options);
    },

    /// **get** returns the value of an attribute.
    _get: function(attr) {
      if (attr == null) return this.attributes;

      var result = this.attributes[attr];
      if (result == undefined) {
        return JSONPath.get(this.attributes, attr);
      }
      return result;
    },

    get: function(attr) {
      var result = this._get.apply(this, arguments);
      if (_.isObject(result)) {
        return clone(result);
      }
      return result;
    },

    _validate: function(attrs, options) {
      return true;
    },


    add: function(key, val, options) {
      // console.log("TreeModel.set", key, val);
      var attr, attrs;
      if (key == null) return this;

      var keyPath = [];
      var parsedPath = JSONPath.parsePath(key);
      var silent = options && options.silent || this.silent; // general override, if it should be silent.
      // var unset = options && options.unset;
      var path = (options && options.path) || [];
      if (! _.isArray(path)) {
        path = JSONPath.parsePath(path);
      }
      // console.log("parsedPath", parsedPath);
      path = path.concat(parsedPath);

      var now = this.attributes;
      // console.log("Before JSPONPath.add(", now, path, val, ")");
      JSONPath.add(now, path, val);
      // console.log("After JSPONPath.add(", now, path, val, ")");
      this._changes.push(path, JSONPath.get(now, path));

      // Signal that the model's state has potentially changed, and we need
      // to recompute the actual changes.
      this._hasComputed = false;

      // Fire the `"change"` events.
      this.invalidateIfNeeded(options);

      if (!silent) this.change(options);
      return this;
    },

    set: function(key, val, options) {
      // console.log("TreeModel.set", key, val);
      var attr, attrs;

      if (key == null && options == null) return this;

      var keyPath = [];
      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (_.isObject(key) && (!_.isArray(key) || options == null)) {
        attrs = key;
        options = val;
      } else {
        var parsedPath = [];
        if (key != null) {
          parsedPath = JSONPath.parsePath(key);
        }
        if (parsedPath != null && _.isArray(parsedPath) && parsedPath.length > 0) {
          keyPath = parsedPath.slice(0,-1);
          key = parsedPath[parsedPath.length -1];
        }
        if (key != null) {
          (attrs = {})[key] = val;
        }
      }

      // Extract attributes and options.
      var silent = options && options.silent;
      var singleCompute   = options && options.single;
      var unset = options && options.unset;
      var path = (options && options.path) || [];
      if (! _.isArray(path)) {
        path = JSONPath.parsePath(path);
      }
      
      // case: we have path but no key
      if (attrs == null && keyPath.length == 0 && path.length > 0) {
        key = path[path.length - 1];
        // console.log(key);
        path = path.slice(0, -1);
        (attrs = {})[key] = val;
      }

      path = path.concat(keyPath);
      // console.log(attrs);
      // Run validation.
      if (!this._validate(attrs, options)) return false;

      var now = this.attributes;
      if (_.isArray(attrs) && path.length > 0) {
        // set in one stroke, since we want to replace the array.
        var obj = {};
        var lastElt = path.length - 1;
        obj[path[path.length -1]] = attrs;
        attrs = obj;
        path.splice(lastElt, 1);
      }

      var isArray = _.isArray(attrs);
      for (attr in attrs) {
        if (isArray) {
          attr = parseInt(attr);
        }
        var attrval = attrs[attr];
        var attrpath = path.concat(attr);
        // console.log(attr);
        // console.log(attrpath);
        if (unset) {
          // console.log("before JSONPath.unset", now, attrpath);
          JSONPath.unset(now, attrpath);
          // console.log("after JSONPath.unset", now, attrpath);
        }
        else if(singleCompute) {

        }
        else {
          // console.log("before JSONPath.set", JSON.stringify(now), attrpath, attrval);
          JSONPath.set(now, attrpath, attrval);
          // console.log("after JSONPath.set", JSON.stringify(now), attrpath, attrval);
        }

          // if we know that
        this._changes.push(attrpath, attrval);
      }
      // Signal that the model's state has potentially changed, and we need
      // to recompute the actual changes.
      this._hasComputed = false;

      // Fire the `"change"` events.
      this.invalidateIfNeeded(options);

      if (!silent) this.change(options);

      this._reValidate();

      return this;
    },
    
    unset: function(key, options) {
      return this.set(key, undefined, _.extend({}, options, {unset: true}));
    },

    // Clear all attributes on the model, firing `"change"` unless you choose
    // to silence it.
    clear: function(options) {
      var attrs = {};
      for (var key in this.attributes) attrs[key] = void 0;
      return this.set(attrs, _.extend({}, options, {unset: true}));
    },

    invalidateIfNeeded: function (options) {
      if (this._changes.length > 0)
        this.trigger('invalidate', this, options);
    },

    change: function(options) {
      // we do not want to trigger chagnes, if we are silent.
      if (this.silent) return;
      var options = options || {};
      // TODO: Only trigger the properties in the current
      //       path
      var path =  (options && options.path) || [];

      var changing = this._changing;
      this._changing = true;

      var triggers = this._computeChanges(true, options.force);

      this._pending = triggers.length > 0;

      for (var i = triggers.length - 2; i >= 0; i -= 2) {
        this.trigger('changeattr', this, triggers[i], triggers[i + 1], options);
      }

      if (changing) return this;

      // Trigger a `change` while there have been changes.
      while (this._pending) {
        this._pending = false;
        this.trigger('change', this, options);
        this._previousAttributes = clone(this.attributes);
      }

      this._changing = false;
      return this;

    },

    // Looking at the built up list of `set` attribute changes, compute how
    // many of the attributes have actually changed. If `loud`, return a
    // boiled-down list of only the real changes.
    _computeChanges: function(loud, force) {
      this.changed = {};
      var already = {};
      var triggers = [];
      var current = this._currentAttributes;
      var changes = this._changes;

      // Loop through the current queue of potential model changes.
      for (var i = changes.length - 2; i >= 0; i -= 2) {
        // TODO: collect same leading paths and save the iteration
        var path = changes[i], val = changes[i + 1];
        var pathString = JSONPath.stringifyPath(path);

        // since:
        // - we append new changes to the end, and
        // - iterate from back to front
        // we ignore previous changes on the object
        if (already[pathString]) continue;
        already[pathString] = true;

        // Check if the attribute has been modified since the last change,
        // and update `this.changed` accordingly. If we're inside of a `change`
        // call, also add a trigger to the list.
        if (force || JSONPath.get(current, path) !== val) {
          this.changed[pathString] = val;
          if (!loud) continue;
          triggers.push(path, val);
          if (val != null) {
            JSONPath.set(current, pathString, clone(val));
          }
          else {
            JSONPath.unset(current, pathString);
          }
        }
      }
      if (loud) this._changes = [];

      // Signals `this.changed` is current to prevent duplicate calls from `this.hasChanged`.
      this._hasComputed = true;
      return triggers;
    },

    toJSON: function(atts) {
      if (atts == null)
        atts = this.attribute;
      // console.log("toJSON: ");
      return clone(atts);
    },

    exists: function() {
      return this.attributes != null;
    },

    /* action state is state that is only set for one comuptation */
    resetActionState: function() {}

  });

  TreeModel.extend = Backbone.Model.extend;
  return TreeModel;
});
